// Configuración de EmailJS
// Para obtener estas credenciales:
// 1. Ve a https://www.emailjs.com/ y crea una cuenta gratuita
// 2. Crea un servicio de email (Gmail, Outlook, etc.)
// 3. Crea una plantilla de email con las variables: {{from_name}}, {{from_email}}, {{phone}}, {{company}}, {{sector}}, {{message}}
// 4. Obtén tu Public Key desde Account > API Keys

export const emailjsConfig = {
  serviceID: 'service_jlwb21j',
  templateID: 'template_iisfv6z',
  publicKey: 'l64P9TgTs3WZlfXSH',
  toEmail: 'contact@myntar.tech'
};
